var map = {
	"./allbook.vue": [
		"lu+U",
		6
	],
	"./answer.vue": [
		"v3Qu",
		1
	],
	"./answer_new.vue": [
		"8imj",
		0
	],
	"./book.vue": [
		"NMIy",
		9
	],
	"./bookabout.vue": [
		"sV7x",
		5
	],
	"./buy.vue": [
		"cxV5",
		7
	],
	"./home.vue": [
		"lyB/",
		2
	],
	"./my.vue": [
		"h59G",
		3
	],
	"./sousuo.vue": [
		"MVIB",
		4
	],
	"./test.vue": [
		"kq+U",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "msXg";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/page lazy ^\.\/.*\.vue$
// module id = msXg
// module chunks = 11